import { insertHorizontal } from './horizontal';
import { insertVertical } from './vertical';
import { insertDiagonal, selectDiagonalDirection } from './diagonal';

export function normalizeWordDirection(word, direction) {
  const isInverted = direction.toLowerCase().startsWith('inverted');

  if (isInverted) {
    return word.split('').reverse().join('');
  }

  return word;
}

export function insertWordBasedOnStrategy(engine, word, direction, isAllDiagonalEnabled, game) {
  const baseDirection = direction.replace(/^inverted/i, '').toLowerCase();

  if (baseDirection.includes('horizontal')) {
    return insertHorizontal(engine, word, direction, game);
  }

  if (baseDirection.includes('vertical')) {
    return insertVertical(engine, word, direction, game);
  }

  const isReversedDiagonalStrategy = direction === 'invertedDiagonal';
  const wordsPlacedQuantity = game.settings.placedWords.length;
  const specificDiagonalDirection = selectDiagonalDirection(
    wordsPlacedQuantity,
    isAllDiagonalEnabled,
    isReversedDiagonalStrategy,
  );

  return insertDiagonal(engine, word, specificDiagonalDirection, game);
}
